import * as Inovx from '@shared';
import FacilityConstants from '../constants/FacilityConstants';
import ViewerConstants from '../constants/ViewerConstants';
import SettingServices from './../services/SettingServices';
function receiveSettings(settings: IFacilitySettings) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: ViewerConstants.VIEWER_RECEIVE_SETTINGS,
        data: settings
    });
}

var SettingActions = {
    getSettings() {
        return new Promise<IFacilitySettings>((resolve, reject) => {
            SettingServices.getSettings(
                function (data) {
                    receiveSettings(data);
                    resolve(data);
                }, function (error) {
                    reject(error);
                });
        });
    },
    setSettings(settings: IFacilitySettings) {
        return new Promise<IFacilitySettings>((resolve, reject) => {
            SettingServices.setSettings(
                settings,
                function () {
                    receiveSettings(settings);
                    resolve(settings);
                }, function (error) {
                    reject(error);
                })
        });
    }
}

export default SettingActions;
